module.exports = __webpack_public_path__ + "static/img/Systherm_Logo.9387331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Systherm_Logo.png
// module id = TjxA
// module chunks = 1